export const spaces = {
  borderline: "0.0625rem",
  small: "0.5rem",
  medium: "0.75rem",
};
